import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import { Layout } from "antd";
import HistoryDisplay from "./containers/history-display";

function AppNavigation (props) {
    const { Content } = Layout;
 
    return (
        <Router>
            <Content>
            <Switch>
                <Route path="/">
                    <HistoryDisplay/>
                </Route>
            </Switch>
            </Content>
        </Router>
    );
}
export default  AppNavigation;